import ReactDOM from "react-dom";

const rootID = "action-menu-portal";

export default function Portal({ children }){
	let rootNode = document.getElementById(rootID);
	if(!rootNode){
		let newNode = document.createElement("div");
		newNode.id = rootID;
		document.body.appendChild(newNode);
		rootNode = newNode;
	}

	return ReactDOM.createPortal(
		children,
		rootNode
	);
}
